import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";
import { formatBreakTimer } from "libs/context/serverTimeBridge";

const BreakTimerModal = ({
  isOpen,
  breakSeconds = 0,
  onResume,
  isResuming = false,
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    document.body.classList.add("break-timer-modal-open");
    return () => document.body.classList.remove("break-timer-modal-open");
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div className="break-timer-modal" role="presentation">
      <div className="break-timer-modal__overlay" aria-hidden="true" />
      <div
        className="break-timer-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="break-timer-modal-title"
      >
        <div className="break-timer-modal__content">
          <p id="break-timer-modal-title" className="break-timer-modal__label">
            On Break
          </p>
          <div className="break-timer-modal__time">
            {formatBreakTimer(breakSeconds)}
          </div>
          <button
            type="button"
            className="break-timer-modal__resume-btn"
            onClick={onResume}
            disabled={isResuming}
          >
            {isResuming ? (
              <>
                <i className="fa fa-spinner fa-spin break-timer-modal__resume-icon" />
                Resuming...
              </>
            ) : (
              <>
                <span
                  className="break-timer-modal__resume-icon"
                  aria-hidden="true"
                >
                  <span className="break-timer-modal__resume-icon-ring" />
                  <span className="break-timer-modal__resume-icon-dot" />
                </span>
                Resume
              </>
            )}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

BreakTimerModal.propTypes = {
  isOpen: PropTypes.bool,
  breakSeconds: PropTypes.number,
  onResume: PropTypes.func,
  isResuming: PropTypes.bool,
};

export default BreakTimerModal;
